import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { HeaderService } from "../../../../views/services/header.service";
import { AdaReviewData } from "../../common/models/adareviewdata";
import { ChronicReviewData } from "../../common/models/chronicreviewdata";
import { EleReviewData } from "../../common/models/elereviewdata";
import { LanguageReviewData } from "../../common/models/languagereviewdata";
import { MbeReviewData } from "../../common/models/mbereviewdata";
import { PsychometricReviewData } from "../../common/models/psychometricreviewdata";
import { ReviewDetail } from "../../common/models/reviewdetails";
import { AccommSupportReviewService } from "../services/accommsupportreview.service";
import { PersonRequestService } from "../services/person-request-service";
import { AppService } from "../../../../views/services/app.service";
import { User } from "../../../../views/services/user.model";

@Component({
  templateUrl: "./accomms-support-review.component.html"
})
export class AccommSupportReviewComponent implements OnInit, OnDestroy {
  psychometricReviewData: PsychometricReviewData = {};
  mbeReviewData: MbeReviewData = {};
  chronicReviewData: ChronicReviewData = {};
  adaReviewData: AdaReviewData = {};
  eleReviewData: EleReviewData = {};
  languageReviewData: LanguageReviewData = {};
  reviewDetail: ReviewDetail = {};
  public internalDecisions: any;
  public reviewDetailId: any;
  public requestId: any;
  public statusFlag: any;
  public status_cd: any;
  public decision: any;
  public consultantId: any;
  public userConsultantId: any;
  public reviewStepCd: any;
  public requestStatusCodeId: any;
  public psychometricFlag: boolean;
  public mbeFlag: boolean;
  public languageFlag: boolean;
  public chronicFlag: boolean;
  public adaFlag: boolean;
  public eleFlag: boolean;
  public reviewDetailFlag: boolean;
  public reviewDetailIdObj: any;
  public loggedInUser: any;
  public userProfile: User;
  public lastReviewerName: any;
  public consultantName: any;
  public enablesavebtn: any;
  public disableButton: boolean;
  public flag: boolean;
  public pageErrorCount: number;
  public limitedEngErr: boolean;
  public engProficencyErr: boolean;
  public reqSupportErr: boolean;
  public accommNeededErr: boolean;
  public substantialLimitErr: boolean;
  public diaImpairErr: boolean;
  public limitationErr: boolean;
  public audioFullReportErr: boolean;
  public needQualCondErr: boolean;
  public subsLimitErr: boolean;
  public altExplanErr: boolean;
  public limitAssementErr: boolean;
  constructor(
    private accommSupportReviewService: AccommSupportReviewService,
    private personRequestService: PersonRequestService,
    private appService: AppService,
    public router: Router
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    if (sessionStorage.getItem("reviewDetailId")) {
      this.reviewDetailId = sessionStorage.getItem("reviewDetailId");
    } else {
      this.reviewDetailId = "";
    }
    this.lastReviewerName = sessionStorage.getItem("lastReviewerName");
    this.reviewStepCd = sessionStorage.getItem("reviewStepCd");
    this.consultantId = sessionStorage.getItem("consultantId");
    this.userConsultantId = sessionStorage.getItem("userConsultantId");
    this.consultantName = sessionStorage.getItem("userConsultantName");
    this.status_cd = sessionStorage.getItem("status_cd");
    this.decision = sessionStorage.getItem("dec");
    this.requestId = sessionStorage.getItem("requestId");
    this.requestStatusCodeId = sessionStorage.getItem("requestStatusCodeId");
    if (this.decision && this.decision === "s") {
      this.statusFlag = true;
    } else {
      this.statusFlag = false;
    }
    this.flag = false;

    if (this.lastReviewerName) {
      if (
        this.status_cd !== "InReview" &&
        this.lastReviewerName !== this.consultantName
      ) {
        this.disableButton = true;
      } else if (
        this.status_cd === "InReview" &&
        this.lastReviewerName === this.consultantName
      ) {
        this.disableButton = false;
      } else if (
        this.status_cd === "InReview" &&
        this.lastReviewerName !== this.consultantName
      ) {
        this.disableButton = true;
      } else if (
        this.status_cd !== "InReview" &&
        this.lastReviewerName === this.consultantName
      ) {
        this.disableButton = true;
      }
    } else {
      this.disableButton = false;
    }

    Observable.forkJoin(
      this.accommSupportReviewService.getPsychometricReviewData(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getMBEReviewData(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getLanguageReviewData(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getChronicReviewData(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getADAReviewData(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getELEReviewData(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getDecisions(
        this.reviewDetailId,
        this.requestId
      ),
      this.accommSupportReviewService.getRequestComment(
        this.reviewDetailId,
        this.requestId
      )
    ).subscribe(([psyRD, mbeRD, lRD, cRD, adaRD, ellRD, iD, rD]) => {
      if (psyRD.body[0]) {
        this.psychometricReviewData = psyRD.body[0];
      } else {
        this.psychometricFlag = true;
      }
      if (mbeRD.body[0]) {
        this.mbeReviewData = mbeRD.body[0];
      } else {
        this.mbeFlag = true;
      }
      if (lRD.body[0]) {
        this.languageReviewData = lRD.body[0];
      } else {
        this.languageFlag = true;
      }
      if (cRD.body[0]) {
        this.chronicReviewData = cRD.body[0];
      } else {
        this.chronicFlag = true;
      }
      if (adaRD.body[0]) {
        this.adaReviewData = adaRD.body[0];
      } else {
        this.adaFlag = true;
      }
      if (ellRD.body[0]) {
        this.eleReviewData = ellRD.body[0];
      } else {
        this.eleFlag = true;
      }
      if (iD.body) {
        this.internalDecisions = iD.body;
      }
      if (rD.body[0]) {
        this.reviewDetail = rD.body[0];
      } else {
        this.reviewDetailFlag = true;
      }
    });
    this.appService.getUserProfile().then(user => this.userProfile = user);
  }

  onSave(navigate) {
    this.disableButton = true;
    this.flag = navigate;
    this.checkCommentText();
  }

  checkCommentText() {
    this.accommNeededErr = false;
    this.limitedEngErr = false;
    this.reqSupportErr = false;
    this.engProficencyErr = false;
    this.substantialLimitErr = false;
    this.diaImpairErr = false;
    this.limitationErr = false;
    this.audioFullReportErr = false;
    this.needQualCondErr = false;
    this.subsLimitErr = false;
    this.altExplanErr = false;
    this.limitAssementErr = false;
    this.pageErrorCount = 0;
    const pattern = /^[a-zA-Z\d\s\-\,\.\@\#\&\/\'\)\(\:\?\!\<\>\+\;\[\]\{\}\=\%\"\\]{1,250}$/;

    if (
      this.psychometricReviewData.SUBS_LIMIT_COMMENT_TX &&
      !pattern.test(this.psychometricReviewData.SUBS_LIMIT_COMMENT_TX)
    ) {
      this.subsLimitErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.psychometricReviewData.ALT_EXPLANATION_COMMENT_TX &&
      !pattern.test(this.psychometricReviewData.ALT_EXPLANATION_COMMENT_TX)
    ) {
      this.altExplanErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.psychometricReviewData.NEED_QUAL_COND_COMMENT_TX &&
      !pattern.test(this.psychometricReviewData.NEED_QUAL_COND_COMMENT_TX)
    ) {
      this.needQualCondErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.languageReviewData.AUDIO_FULL_REPORT_COMMENT_TX &&
      !pattern.test(this.languageReviewData.AUDIO_FULL_REPORT_COMMENT_TX)
    ) {
      this.audioFullReportErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.languageReviewData.LIMITATION_COMMENT_TX &&
      !pattern.test(this.languageReviewData.LIMITATION_COMMENT_TX)
    ) {
      this.limitationErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.chronicReviewData.LIMIT_ASSESSMENT_COMMENT_TX &&
      !pattern.test(this.chronicReviewData.LIMIT_ASSESSMENT_COMMENT_TX)
    ) {
      this.limitAssementErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.adaReviewData.DIAGNOSED_IMPAIR_COMMENT_TX &&
      !pattern.test(this.adaReviewData.DIAGNOSED_IMPAIR_COMMENT_TX)
    ) {
      this.diaImpairErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.adaReviewData.SUBSTANTIAL_LIMIT_COMMENT_TX &&
      !pattern.test(this.adaReviewData.SUBSTANTIAL_LIMIT_COMMENT_TX)
    ) {
      this.substantialLimitErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.adaReviewData.ACCOMMS_NEED_COMMENT_TX &&
      !pattern.test(this.adaReviewData.ACCOMMS_NEED_COMMENT_TX)
    ) {
      this.accommNeededErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.eleReviewData.REQUESTED_SUPPORT_COMMENT_TX &&
      !pattern.test(this.eleReviewData.REQUESTED_SUPPORT_COMMENT_TX)
    ) {
      this.reqSupportErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.eleReviewData.ENGLISH_PROFICIENCY_COMMENT_TX &&
      !pattern.test(this.eleReviewData.ENGLISH_PROFICIENCY_COMMENT_TX)
    ) {
      this.engProficencyErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }
    if (
      this.eleReviewData.LIMITED_ENGLISH_COMMENT_TX &&
      !pattern.test(this.eleReviewData.LIMITED_ENGLISH_COMMENT_TX)
    ) {
      this.limitedEngErr = true;
      this.pageErrorCount = this.pageErrorCount + 1;
    }

    if (this.pageErrorCount === 0) {
      this.checkReviewDetailId();
    }
  }
  checkReviewDetailId() {
    if (this.reviewDetailId === "") {
      const data = {
        reviewStepCd: this.reviewStepCd,
        requestStatusCodeId: this.requestStatusCodeId,
        requestId: this.requestId,
        consultantId: this.consultantId
      };
      Observable.forkJoin(
        this.personRequestService.createReviewDetailId(data)
      ).subscribe(([Response]) => {
        if (Response) {
          this.reviewDetailIdObj = Response.body;
          this.reviewDetailId = this.reviewDetailIdObj.REVIEW_DETAIL_ID;
          sessionStorage.setItem("reviewDetailId", this.reviewDetailId);
          this.update();
        }
      });
    } else {
      this.update();
    }
  }

  update() {
    if (!this.psychometricFlag) {
      this.psychometricReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.updatePsychometricReviewData(
          this.psychometricReviewData
        )
      ).subscribe(psyRD => {
        //todo
        //handle the response/ error conditions
      });
    } else {
      this.psychometricReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.createPsychometricReviewData(
          this.psychometricReviewData
        )
      ).subscribe(([psyRD]) => {
        //todo
        //handle the response/ error conditions
        if (psyRD.status === 200) {
          this.psychometricFlag = false;
        }
      });
    }
    if (!this.mbeFlag) {
      this.mbeReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.updateMBEReviewData(this.mbeReviewData)
      ).subscribe(mbeRD => { });
    } else {
      this.mbeReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.createMBEReviewData(this.mbeReviewData)
      ).subscribe(([mbeRD]) => {
        if (mbeRD.status === 200) {
          this.mbeFlag = false;
        }
      });
    }
    if (!this.languageFlag) {
      this.languageReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.updateLanguageReviewData(
          this.languageReviewData
        )
      ).subscribe(lRD => { });
    } else {
      this.languageReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.createLanguageReviewData(
          this.languageReviewData
        )
      ).subscribe(([lRD]) => {
        if (lRD.status === 200) {
          this.languageFlag = false;
        }
      });
    }
    if (!this.chronicFlag) {
      this.chronicReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.updateChronicReviewData(
          this.chronicReviewData
        )
      ).subscribe(cRD => { });
    } else {
      this.chronicReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.createChronicReviewData(
          this.chronicReviewData
        )
      ).subscribe(([cRD]) => {
        if (cRD.status === 200) {
          this.chronicFlag = false;
        }
      });
    }
    if (!this.adaFlag) {
      this.adaReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.updateADAReviewData(this.adaReviewData)
      ).subscribe(adaRD => { });
    } else {
      this.adaReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.createADAReviewData(this.adaReviewData)
      ).subscribe(([adaRD]) => {
        if (adaRD.status === 200) {
          this.adaFlag = false;
        }
      });
    }
    if (!this.eleFlag) {
      this.eleReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.updateELEReviewData(this.eleReviewData)
      ).subscribe(ellRD => { });
    } else {
      this.eleReviewData.REVIEW_DETAIL_ID = this.reviewDetailId;
      Observable.forkJoin(
        this.accommSupportReviewService.createELEReviewData(this.eleReviewData)
      ).subscribe(([ellRD]) => {
        if (ellRD.status === 200) {
          this.eleFlag = false;
        }
      });
    }
    if (!this.reviewDetailFlag) {
      this.reviewDetail.REVIEW_DETAIL_ID = this.reviewDetailId;
      this.reviewDetail.UPDATED_BY_DS = this.userProfile.loggedInUser;
      Observable.forkJoin(
        this.accommSupportReviewService.updateRequestComment(this.reviewDetail)
      ).subscribe(rC => { });
    } else {
      this.reviewDetail.REVIEW_DETAIL_ID = this.reviewDetailId;
      this.reviewDetail.UPDATED_BY_DS = this.userProfile.loggedInUser;
      Observable.forkJoin(
        this.accommSupportReviewService.createRequestComment(this.reviewDetail)
      ).subscribe(([rC]) => {
        if (rC.status === 200) {
          this.reviewDetailFlag = false;
        }
      });
    }
    if (this.flag) {
      this.router.navigate(["consultantDecision"]);
    }
  }

  toBack() {
    this.router.navigate(["exreqdetails"]);
  }

  updateSelection(selected, model, field) {
    if (
      selected === "Yes" &&
      model === "psychometricReviewData" &&
      field === "ALT_EXPLANATION_FL"
    ) {
      this.psychometricReviewData.ALT_EXPLANATION_FL = 1;
    } else if (
      selected === "No" &&
      model === "psychometricReviewData" &&
      field === "ALT_EXPLANATION_FL"
    ) {
      this.psychometricReviewData.ALT_EXPLANATION_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "psychometricReviewData" &&
      field === "SUBS_LIMIT_FL"
    ) {
      this.psychometricReviewData.SUBS_LIMIT_FL = 1;
    } else if (
      selected === "No" &&
      model === "psychometricReviewData" &&
      field === "SUBS_LIMIT_FL"
    ) {
      this.psychometricReviewData.SUBS_LIMIT_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "psychometricReviewData" &&
      field === "NEED_QUAL_COND_FL"
    ) {
      this.psychometricReviewData.NEED_QUAL_COND_FL = 1;
    } else if (
      selected === "No" &&
      model === "psychometricReviewData" &&
      field === "NEED_QUAL_COND_FL"
    ) {
      this.psychometricReviewData.NEED_QUAL_COND_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "mbeReviewData" &&
      field === "EVIDENCE_CONT_LIMIT_FL"
    ) {
      this.mbeReviewData.EVIDENCE_CONT_LIMIT_FL = "1";
    } else if (
      selected === "No" &&
      model === "mbeReviewData" &&
      field === "EVIDENCE_CONT_LIMIT_FL"
    ) {
      this.mbeReviewData.EVIDENCE_CONT_LIMIT_FL = "0";
    } else if (
      selected === "Yes" &&
      model === "languageReviewData" &&
      field === "AUDIO_FULL_REPORT_FL"
    ) {
      this.languageReviewData.AUDIO_FULL_REPORT_FL = 1;
    } else if (
      selected === "No" &&
      model === "languageReviewData" &&
      field === "AUDIO_FULL_REPORT_FL"
    ) {
      this.languageReviewData.AUDIO_FULL_REPORT_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "languageReviewData" &&
      field === "LIMITATION_FL"
    ) {
      this.languageReviewData.LIMITATION_FL = 1;
    } else if (
      selected === "No" &&
      model === "languageReviewData" &&
      field === "LIMITATION_FL"
    ) {
      this.languageReviewData.LIMITATION_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "chronicReviewData" &&
      field === "LIMIT_ASSESSMENT_TX"
    ) {
      this.chronicReviewData.LIMIT_ASSESSMENT_TX = "1";
    } else if (
      selected === "No" &&
      model === "chronicReviewData" &&
      field === "LIMIT_ASSESSMENT_TX"
    ) {
      this.chronicReviewData.LIMIT_ASSESSMENT_TX = "0";
    } else if (
      selected === "Yes" &&
      model === "adaReviewData" &&
      field === "DIAGNOSED_IMPAIR_FL"
    ) {
      this.adaReviewData.DIAGNOSED_IMPAIR_FL = 1;
    } else if (
      selected === "No" &&
      model === "adaReviewData" &&
      field === "DIAGNOSED_IMPAIR_FL"
    ) {
      this.adaReviewData.DIAGNOSED_IMPAIR_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "adaReviewData" &&
      field === "SUBSTANTIAL_LIMIT_FL"
    ) {
      this.adaReviewData.SUBSTANTIAL_LIMIT_FL = 1;
    } else if (
      selected === "No" &&
      model === "adaReviewData" &&
      field === "SUBSTANTIAL_LIMIT_FL"
    ) {
      this.adaReviewData.SUBSTANTIAL_LIMIT_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "adaReviewData" &&
      field === "ACCOMMS_NEED_FL"
    ) {
      this.adaReviewData.ACCOMMS_NEED_FL = 1;
    } else if (
      selected === "No" &&
      model === "adaReviewData" &&
      field === "ACCOMMS_NEED_FL"
    ) {
      this.adaReviewData.ACCOMMS_NEED_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "eleReviewData" &&
      field === "REQUESTED_SUPPORT_FL"
    ) {
      this.eleReviewData.REQUESTED_SUPPORT_FL = 1;
    } else if (
      selected === "No" &&
      model === "eleReviewData" &&
      field === "REQUESTED_SUPPORT_FL"
    ) {
      this.eleReviewData.REQUESTED_SUPPORT_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "eleReviewData" &&
      field === "LIMITED_ENGLISH_FL"
    ) {
      this.eleReviewData.LIMITED_ENGLISH_FL = 1;
    } else if (
      selected === "No" &&
      model === "eleReviewData" &&
      field === "LIMITED_ENGLISH_FL"
    ) {
      this.eleReviewData.LIMITED_ENGLISH_FL = 0;
    } else if (
      selected === "Yes" &&
      model === "eleReviewData" &&
      field === "ENGLISH_PROFICIENCY_FL"
    ) {
      this.eleReviewData.ENGLISH_PROFICIENCY_FL = 1;
    } else if (
      selected === "No" &&
      model === "eleReviewData" &&
      field === "ENGLISH_PROFICIENCY_FL"
    ) {
      this.eleReviewData.ENGLISH_PROFICIENCY_FL = 0;
    }
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/accomms-support-review/accomms-support-review.component.ts